import { Ref, ref, nextTick, readonly } from 'vue'

export const useWheelScale = (container: Ref<HTMLElement | undefined>, maxScale = 3) => {
  const minScale = 1
  const scale = ref(minScale)

  const onWheel = async (event: WheelEvent) => {
    const step = .5
    if (event.deltaY < 0) {
      if (scale.value === maxScale) {
        return
      }

      scale.value = scale.value + step
    } else {
      if (scale.value === minScale) {
        return
      }

      scale.value = scale.value - step
    }

    if (scale.value === minScale || !container.value) {
      return
    }

    await nextTick()

    const { clientX, clientY } = event
    const rect = container.value?.getBoundingClientRect()

    container.value.scrollLeft = ((clientX - rect.left) * scale.value) / 2
    container.value.scrollTop = ((clientY - rect.top) * scale.value) / 2
  }

  const init = (element: HTMLElement) => {
    element.addEventListener('wheel', onWheel)
  }

  const setDefault = () => scale.value = minScale

  const destroy = (element: HTMLElement) => element.removeEventListener('wheel', onWheel)

  return {
    scale: readonly(scale),
    init,
    destroy,
    setDefault,
  }
}
